var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    transform: "matrix(-1 0 0 1 125 25)",
    fill: "#CC9C33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 55.5,
    cy: 55.5,
    r: 54,
    transform: "matrix(-1 0 0 1 130 20)",
    stroke: "#CC9C33",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9211 100C67.4681 100.003 66.0536 99.5244 64.891 98.6372L64.8189 98.5821L49.6418 86.753C48.939 86.2048 48.349 85.521 47.9057 84.7406C47.4625 83.9603 47.1745 83.0987 47.0583 82.2051C46.9421 81.3115 47 80.4034 47.2285 79.5325C47.4571 78.6616 47.8519 77.8451 48.3905 77.1296C48.929 76.4141 49.6008 75.8136 50.3673 75.3623C51.1338 74.911 51.9802 74.6179 52.858 74.4996C53.7358 74.3813 54.6279 74.4402 55.4834 74.6729C56.3389 74.9056 57.141 75.3075 57.8438 75.8557L67.6744 83.5293L90.9056 52.6875C91.4444 51.9721 92.1163 51.3718 92.883 50.9208C93.6497 50.4698 94.4962 50.177 95.374 50.059C96.2519 49.9411 97.144 50.0003 97.9994 50.2333C98.8548 50.4663 99.6567 50.8686 100.359 51.4171L100.215 51.6167L100.363 51.42C101.781 52.529 102.708 54.165 102.942 55.9692C103.176 57.7734 102.697 59.5984 101.611 61.0438L74.2856 97.3212C73.6536 98.1571 72.8409 98.8336 71.9106 99.2982C70.9803 99.7628 69.9573 100.003 68.9211 100Z",
    fill: "#F2F2F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1193,
    cy: 19.0999,
    r: 5.9129,
    fill: "#CC9C33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1968,
    cy: 16.3709,
    r: 3.18387,
    fill: "#CC9C33"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.829,
    cy: 40.9322,
    r: 3.18387,
    fill: "#CC9C33"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5484,
    cy: 73.2259,
    r: 4.54839,
    fill: "#CC9C33"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8225,
    cy: 113.706,
    r: 3.18387,
    fill: "#CC9C33"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9225,
    cy: 134.174,
    r: 4.54839,
    fill: "#CC9C33"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0322,
    cy: 136.903,
    r: 1.81935,
    fill: "#CC9C33"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.1387,
    cy: 141.907,
    r: 4.09355,
    fill: "#CC9C33"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.606,
    cy: 135.993,
    r: 2.72903,
    fill: "#CC9C33"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.623,
    cy: 125.532,
    r: 4.09355,
    fill: "#CC9C33"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.99,
    cy: 106.429,
    r: 2.27419,
    fill: "#CC9C33"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.178,
    cy: 89.145,
    r: 2.27419,
    fill: "#CC9C33"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.903,
    cy: 55.0323,
    r: 4.54839,
    fill: "#CC9C33"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.168,
    cy: 49.5742,
    r: 2.72903,
    fill: "#CC9C33"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.245,
    cy: 25.013,
    r: 2.72903,
    fill: "#CC9C33"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7742,
    cy: 7.72903,
    r: 2.72903,
    fill: "#CC9C33"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.529,
    cy: 18.6451,
    r: 4.54839,
    fill: "#CC9C33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1f8d9eae1f65ff64bfc3b6966b00bba3.svg";
export { ForwardRef as ReactComponent };